<template>
  <div class="transaction-person-component">
    <avatar :user="person" size="80" />
    <div class="name">
      <span v-if="person.role" class="person-role">{{ person.role.name }}</span>
      <span>{{ person.name }}</span>
    </div>
  </div>
</template>

<script>
  import Avatar from '@/components/administrator/work-shift/staff/Avatar.vue'

  export default {
    name: 'TransactionPerson',
    components: { Avatar },
    props: {
      person: {
        type: Object,
        default: () => ({}),
      },
    },
  }
</script>

<style lang="less" scoped>
  .transaction-person-component {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    background-color: #EFF0F4;
    border-radius: 10px;
    padding: 25px 30px;

    .avatar {
      //width: 93px;
      //height: 93px;
      background-color: @color-primary;
      border-radius: 50%;
      overflow-y: hidden;
      margin-right: 20px;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .name {
      font-size: 25px;
      line-height: 1.1;

      .person-role {
        font-size: 16px;
        display: block;
        line-height: 18px;
      }
    }
  }
</style>
